import React, { useEffect, useState } from 'react';
import { Modal } from '@maxtropy/components';
import {
  apiV2WaterMapDataFlowmeterDataPost,
  V2WaterMapDataFlowmeterDataPostResponse,
} from '@maxtropy/device-customer-apis-v2';
import { formatThousandAndUnit } from '@/utils/utils';
import styles from './index.module.scss';
import { Spin } from 'antd';

export type FlowmeterData = Exclude<V2WaterMapDataFlowmeterDataPostResponse['list'], undefined>[number];

interface FlowmeterModalProps {
  open: boolean;
  flowmeter?: FlowmeterData;
  onClose: () => void;
}

const formatWaterUsage = (value?: number) => {
  const formatted = formatThousandAndUnit(value);
  return `${formatted.value}${formatted.unit}m³`;
};

const FlowmeterModal: React.FC<FlowmeterModalProps> = ({ open, flowmeter, onClose }) => {
  const [data, setData] = useState<FlowmeterData>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !flowmeter) return;

    let canceled = false;
    setData(flowmeter);
    setLoading(true);
    apiV2WaterMapDataFlowmeterDataPost({})
      .then(response => {
        if (canceled) return;
        setData(response.list?.find(item => item.flowmeterId === flowmeter.flowmeterId) ?? flowmeter);
      })
      .catch(error => {
        console.error('[UnityWaterMap] load flowmeter popup data failed', error);
      })
      .finally(() => {
        if (!canceled) setLoading(false);
      });

    return () => {
      canceled = true;
    };
  }, [flowmeter, open]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      width={360}
      footer={null}
      title={data?.flowmeterName ?? '流量计'}
      className={styles.flowmeterModal}
      destroyOnClose
      getContainer={() => document.getElementById('full_screen_box') ?? document.body}
    >
      <Spin spinning={loading}>
        <div className={styles.content}>
          <div className={styles.row}>
            <span>今日用水量：</span>
            <strong>{formatWaterUsage(data?.dayTotal)}</strong>
          </div>
          <div className={styles.row}>
            <span>本月用水量：</span>
            <strong>{formatWaterUsage(data?.monthTotal)}</strong>
          </div>
        </div>
      </Spin>
    </Modal>
  );
};

export default FlowmeterModal;
